import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as PVActions from './pv-info.action';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';

@Injectable({
  providedIn: 'root'
})
export class PVStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }
  initStore() {
    this.store.dispatch(new PVActions.PVRefresh());
  }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.PVINFO, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new PVActions.PVCreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new PVActions.PVUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new PVActions.PVDelete(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new PVActions.PVRefresh());
          break;

        case SignalRAction.RequestRefresh:
          this.store.dispatch(new PVActions.PVRefreshByID(data.id));
          break;
      }
    });
  }
}
